//#region import
import React, { useEffect, useState } from 'react'
import { Chip, Grid, IconButton, Popover, Tooltip, Typography, Divider } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import { FnAxios, FnDialog } from 'utilities/utilities';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { BtnAddOnTable, BtnEditOnTable, BtnViewOnTable } from 'components/Button/ButtonTable';
import { FilterFieldInterface } from 'components/DataGrid/DataGridProps';
import { GetMenuPermission } from 'utilities/SystemFunction';
import InfoIcon from '@mui/icons-material/Info';
import { EnumStatus } from '../AdminUser/Role/RoleList';
import DialogPreview from 'components/DialogPreview/DialogPreview';
import { Circle, Groups } from '@mui/icons-material';
//#endregion

const ProjectTimelineTable = ({ sMode }) => {
    const navigate = useNavigate();
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const [loadingTable, setLoadingTable] = useState(false);
    const [sUpdateName, setUpdateName] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isOpen, setisOpen] = useState<boolean>(false);
    const [lstUser, setlstUser] = useState([]);
    const [arrFilterYear, setArrFilterYear] = useState([]);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const handleViewInfo = (e) => {
        setUpdateName(e.sUpdateName);//sUpdateName
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);


    const onOpenModal = (e) => {
        setisOpen(true);
        AxiosFn.Post(
            `ProjectTimeline/GetDataUser`,
            { sID: e },
            (res) => {
                setlstUser(res.lstUserName || []);
            },
            (err) => {
                if (!err.response) {
                    DialogFn.Warning(err.Message);
                }
            }
        );
    };

    const dataColumnNormal: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        IsDisabled={!isPermission}
                        onClick={() => navigate("/ProjectTimelineForm?sMode=" + sMode)}
                        id={"Add"} />
                </>
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                }
            },
        },
        {
            field: "sYear",
            headerName: " ปี",
            headerAlign: "center",
            align: "center",
            sortable: true,
            flex: 1,
            width: 220,
        },

        {
            field: "sUpdate",
            headerName: "แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            flex: 1,
            width: 220,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
        {
            field: "sStatus",
            headerName: "สถานะ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 50,
            flex: 0.5,
            renderCell: (item) => {
                return (
                    <>
                        {EnumStatus.Active == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "rgb(22 187 68)",
                                        backgroundColor: "rgb(231 255 237)",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                        {EnumStatus.isActive == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "#f1416c",
                                        backgroundColor: "#fff5f8",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                    </>
                )
            }
        },

    ];


    const dataColumn: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        IsDisabled={!isPermission}
                        onClick={() => navigate("/ProjectTimelineForm?sMode=" + sMode)}
                        id={"Add"} />
                </>
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                }
            },
        },
        {
            field: "sYear",
            headerName: "ปี",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 100,
        },
        {
            field: "nRound",
            headerName: "ครั้งที่",
            headerAlign: "center",
            align: "center",
            width: 100,
        },
        {
            field: "nCount",
            headerName: "เปิดให้กับ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 200,
            flex: 0.5,
            renderCell: (item) => {
                return (
                    <>
                        <Typography variant="body1">{item.row.nCount}</Typography>
                        &nbsp;
                        <Groups
                            sx={{
                                color: "#f8803d !important",
                                "&:hover": {
                                    color: "black !important",
                                },
                                cursor: "pointer",

                            }}
                            onClick={() => onOpenModal(item.row.sID)}
                        />
                    </>
                );
            },
        },
        {
            field: "sStart",
            headerName: "วันที่เปิด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 150,

        },
        {
            field: "sEnd",
            headerName: "วันที่ปิด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 150,
        },

        {
            field: "sUpdate",
            headerName: "แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 220,

            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
        {
            field: "sStatus",
            headerName: "สถานะ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 120,

            renderCell: (item) => {
                return (
                    <>
                        {EnumStatus.Active == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "rgb(22 187 68)",
                                        backgroundColor: "rgb(231 255 237)",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                        {EnumStatus.isActive == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "#f1416c",
                                        backgroundColor: "#fff5f8",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                    </>
                )
            }
        },

    ];

    const getTableTimeline = (p: PaginationInterface) => {
        setLoadingTable(true);
        let Param = {
            ...p,
            nRegisterType: sMode == "Normal" ? 1 : 2
        };
        AxiosFn.Post(`ProjectTimeline/GetTableProjectTimeline`, Param, (result) => {
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: [...result.lstDataTimeline],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
        });
    };

    const getFormInitial = () => {
        let param = {
            nRegisterType: sMode == "Normal" ? 1 : 2
        }
        
        AxiosFn.Post(`ProjectTimeline/GetFormInitial`, param, (result) => {
            setArrFilterYear(result.objResult?.lstFilterYear);
        });
    }

    useEffect(() => {
        getFormInitial();
        getTableTimeline(dataRow);
    }, [sMode]);


    const goToEdit = (sID: string) => {
        navigate(`/ProjectTimelineForm?sMode=${sMode}&sID=${encodeURI(sID)}`);
    };


    //Filter Search
    const filter: FilterFieldInterface[] = [
        // { sTypeFilterMode: "input", sLabel: "ปี", sFieldName: "sYear", nGridLG: 5, nGridMD: 6, nGridSM: 6, nGridXS: 12 },
        { sTypeFilterMode: "multiselect", sLabel: "ปี", sFieldName: "lstYear", optionSelect: arrFilterYear, nGridLG: 5, nGridMD: 6, nGridSM: 6, nGridXS: 12 },
        {
            sTypeFilterMode: "select", sLabel: "สถานะ", sFieldName: "sStatus",
            optionSelect: [
                {

                    label: "ใช้งาน",
                    value: "1"
                },
                {

                    label: "ไม่ใช้งาน",
                    value: "0"
                },

            ],
            nGridLG: 2, nGridMD: 2, nGridSM: 6, nGridXS: 12
        },
    ];

    const onDelete = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            let param = {
                lstID: e,
                sLocation: location.pathname
            }
            AxiosFn.Post(`ProjectTimeline/RemoveDataTable`, param, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTableTimeline(dataRow);
                    });
                }
            });
        });
    }
    return (
        <React.Fragment>
            <Grid item xs={12} sx={{ mt: 1 }}>
                <DataGrid
                    sTableID='tb1'
                    columns={sMode == "Normal" ? dataColumnNormal : dataColumn}
                    rows={dataRow}
                    modeFilter={1}
                    onLoadData={getTableTimeline}
                    isLoading={loadingTable}
                    isHiddenToolHead={false}
                    filterField={filter}
                    isShowCheckBox={isPermission}
                    onRowSelectable={(p) => !p.row.isDelete}
                    onDelete={onDelete}

                />
            </Grid>

            {/* pop over */}
            <Popover
                id={`sUpdateName`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
            </Popover>

            <DialogPreview
                IsOpen={isOpen}
                IsBackdropClick={false}
                onClose={() => { setisOpen(false); }}
                JsxDialogAction
                CloseSave={false}
                Close={false}
                sMaxWidth='sm'
                bgColor={"#a07300"}
                Color='white'
                Title={''}
            >
                <Grid container justifyContent={"center"} >
                    <Grid container justifyContent={"center"} xs={12} md={10} spacing={1} >
                        <Grid item xs={6} md={7} >
                            <Typography style={{ color: "#225192", fontSize: "18px", fontWeight: 500 }}> ชื่อบัญชี </Typography>
                        </Grid >
                        <Grid item xs={6} md={5}>
                            <Typography style={{ color: "#225192", fontSize: "18px", fontWeight: 500 }}> อีเมล </Typography>
                        </Grid >
                    </Grid >
                    <Grid item xs={12} md={12}  >
                        <Divider style={{ color: "#212836" }} />
                    </Grid>
                    {lstUser.map((m) => (
                        <>
                            <Grid container justifyContent={"center"} xs={12} md={10} spacing={1} sx={{ mt: "3px" }}>
                                <Grid item md={7} >
                                    <Typography style={{ color: "#212836", fontSize: "16px", fontWeight: 400 }}>{m.sUserName} </Typography></Grid >
                                <Grid item md={5} >
                                    <Typography style={{ color: "#212836", fontSize: "16px", fontWeight: 400 }}> {m.sEmail} </Typography></Grid >
                            </Grid>

                        </>
                    ))}

                </Grid>
            </DialogPreview >
        </React.Fragment >
    )
}
export default ProjectTimelineTable;

